<script setup lang="ts">
import { onMounted, ref } from "vue";
import { fetchStats } from "../api";

const cards = ref([
  { name: "总上报量", value: 0 },
  { name: "代码错误", value: 0 },
  { name: "接口异常", value: 0 },
  { name: "性能指标", value: 0 },
  { name: "录屏数据", value: 0 },
]);

async function load() {
  try {
    const stats = await fetchStats();
    const byType = stats.byType || {};
    cards.value[0].value = stats.total;
    cards.value[1].value =
      (byType.error || 0) + (byType.unhandledRejection || 0) + (byType.resource || 0);
    cards.value[2].value = (byType.xhr || 0) + (byType.fetch || 0);
    cards.value[3].value = byType.performance || 0;
    cards.value[4].value = byType.recordScreen || 0;
  } catch {
    // 服务端未启动时保持默认值
  }
}

defineExpose({ load });
onMounted(load);
</script>

<template>
  <div class="wrapper">
    <div v-for="item in cards" :key="item.name" class="count">
      <div class="card">
        <p class="name">{{ item.name }}</p>
        <p class="value">{{ item.value }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.card {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background-color: #fff;
  padding: 12px 16px;
}

.name {
  margin: 0;
  font-size: 13px;
  color: #909399;
}

.value {
  margin: 6px 0 0;
  font-size: 24px;
  font-weight: 600;
}
</style>
